import { render, staticRenderFns } from "./Iedi.vue?vue&type=template&id=6fed4924&scoped=true"
import script from "./Iedi.vue?vue&type=script&lang=js"
export * from "./Iedi.vue?vue&type=script&lang=js"
import style0 from "./Iedi.vue?vue&type=style&index=0&id=6fed4924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed4924",
  null
  
)

export default component.exports